// Home.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, Heart, Share2, Edit3, Feather } from 'lucide-react';
import '../styles/Home.css';
import AuthModal from '../components/AuthModal';

function Home() {
  // State for AuthModal visibility and type
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authType, setAuthType] = useState('signup'); // Default olarak 'signup'

  // Function to open the AuthModal
  const openAuthModal = (type) => {
    setAuthType(type);
    setShowAuthModal(true);
  };

  const categories = [
    'Aksiyon', 'Bilim Kurgu', 'Fantastik', 'Genel Kurgu', 'Genç Kurgu',
    'Gerilim', 'Gizem', 'Hayran Kurgu', 'Klasikler', 'Korku',
    'Kısa Hikaye', 'Macera', 'Mizah', 'Paranormal', 'Romantizm',
    'Spiritüel', 'Tarihi Kurgu', 'Texting', 'Vampir', 'Şiir'
  ];

  return (
    <div className="app-container">
      <section className="hero">
        <div className="hero-content">
          <h1>Kitap Tutkunları İçin Sosyal Platform</h1>
          <p>Oku, Paylaş, Keşfet, Yorum Yap - Sınırsız Ücretsiz Okuma Hakkı!</p>
          <button className="cta-button" onClick={() => openAuthModal('signup')}>Hemen Başlayın</button>
        </div>
        <div className="hero-image">
          <img
            src="https://images.unsplash.com/photo-1507842217343-583bb7270b66?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
            alt="Kitap koleksiyonu"
          />
        </div>
      </section>

      <section className="social-features">
        <h2>Librozi'de Sosyalleşin</h2>
        <div className="social-grid">
          <div className="social-card">
            <div className="social-icon">
              <MessageSquare size={32} />
            </div>
            <h3>Kitaplar Hakkında Tartışın</h3>
            <p>Okuduğunuz kitaplar hakkında düşüncelerinizi paylaşın ve diğer okuyucuların yorumlarını görün.</p>
          </div>
          <div className="social-card">
            <div className="social-icon">
              <Heart size={32} />
            </div>
            <h3>Beğenin ve Etkileşimde Bulunun</h3>
            <p>Beğendiğiniz kitap yorumlarını destekleyin, etkileşimde bulunun ve tartışmalara katılın.</p>
          </div>
          <div className="social-card">
            <div className="social-icon">
              <Share2 size={32} />
            </div>
            <h3>Keşiflerinizi Paylaşın</h3>
            <p>Sevdiğiniz kitapları arkadaşlarınızla paylaşın ve okuma listenizi genişletin.</p>
          </div>
          <div className="social-card">
            <div className="social-icon">
              <Edit3 size={32} />
            </div>
            <h3>Kendi Kitabınızı Yazın</h3>
            <p>Yazarlık yeteneğinizi keşfedin ve kendi eserlerinizi toplulukla paylaşın.</p>
          </div>
        </div>
      </section>

      <section className="categories">
        <h2>20 Farklı Kategori, Yüzlerce Kitap</h2>
        <p className="section-description">Tüm kategorilerde sınırsız ücretsiz okuma hakkı</p>
        <div className="category-tags">
          {categories.map((category, index) => (
            <div key={index} className="category-tag">{category}</div>
          ))}
        </div>
      </section>

      <section className="write-section">
        <div className="write-content">
          <div className="write-icon">
            <Feather size={48} />
          </div>
          <h2>Kendi Kitabınızı Yazın ve Paylaşın</h2>
          <p>İçinizdeki yazarı keşfedin. Hikayelerinizi, düşüncelerinizi ve bilgilerinizi kitap formatında paylaşın.</p>
          <button className="write-button" onClick={() => openAuthModal('signup')}>Yazmaya Başlayın</button>
        </div>
      </section>

      <section className="cta-section">
        <div className="cta-content">
          <h2>Okuma Yolculuğunuza Bugün Başlayın</h2>
          <p>Sınırsız ücretsiz okuma hakkı ile kitap dünyasına dalın.</p>
          <button className="cta-button" onClick={() => openAuthModal('signup')}>Ücretsiz Katılın</button>
        </div>
      </section>

      {showAuthModal && (
        <AuthModal 
          type={authType} 
          onClose={() => setShowAuthModal(false)}
        />
      )}

      <footer>
        <div className="footer-content">
          <div className="footer-column">
            <ul>
              <li><Link to="/agreements#privacy">Gizlilik Sözleşmesi</Link></li>
              <li><Link to="/agreements#data-protection">Kişisel Verilerin Korunumu Kanunu</Link></li>
              <li><Link to="/agreements#terms">Hizmet Koşulları</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Librozi. Tüm hakları saklıdır.</p>
        </div>
      </footer>
    </div>
  );
}

export default Home;